<!--<div class="create-ai-image-wrap">
  <div class="create-ai-image-1">
    <div class="create-ai-image">
      <img src="assets/images/ai/onboarding/ai-informative-light.svg" alt="">
    </div>
  </div>
  <div class="create-ai-image-2">
    <div class="create-ai-image">
      <img src="assets/images/ai/onboarding/ai-informative-light-full.svg" alt="">
    </div>
  </div>
</div>-->

<div class="db-left-side" *ngIf="!isMobile">
  <div>
    <i class="db-icon db-icon-ds-ai-generate fadeIn mb14"></i>

    <div class="db-header mb10" [ngClass]="{'blue': !!fromDomains}" textSlideUp data-animate="slideUp1" [animationDuration]="500" [delay]="90" *ngIf="!!fromDomains; else defaultText">
      Secure <span class="blue">{{ fromDomains }}</span> by creating your website with AI
    </div>

    <ng-template #defaultText>
      <div class="db-header mb10" textSlideUp data-animate="slideUp1" [animationDuration]="500" [delay]="90" >
        Let’s start creating<br/>
        your website with AI
      </div>
    </ng-template>

    <div class="db-desc" textSlideUp data-animate="slideUp2"  [animationDuration]="400" [delay]="60">
      Answer a few questions and our AI will generate a personalized  website with tailored content and images.
    </div>
  </div>

</div>

<div class="db-right-side">
  <a class='db-sign-out' (click)="signOut()" *ngIf="emailCampaign && userSubscription?.trialClient"><span>Sign out</span></a>
  <div>
    <h1 class="mb30">
     @if (!!isMobile) {
       What kind of website do you want to<br/> create?
      } @else {
        What kind of website<br/>
        do you want to create?
      }
    </h1>

  <!--  <h4 class="mb30" *ngIf="!!isMobile">
      Answer a few questions and our AI will generate<br/>
      a personalized website with tailored content and images.
    </h4>-->

    <div class="create-ai-assistant-choose-website-type">
      <div [ngClass]="{'selected': websiteType === 'default', 'disabled': websiteType === 'ecommerce' && !!loading.value}">
        <input class="ds-radio-black ds-radio-small" type="radio" id="default" value="default" name="website_type"
               [checked]="websiteType === 'default'" (change)="onWebsiteTypeChange('default')">
        <label for="default">I want to create an informational website</label>
      </div>
      <div [ngClass]="{'selected': websiteType === 'ecommerce', 'disabled': (websiteType === 'default' && !!loading.value)}"
           class="mt20">
        <input class="ds-radio-black ds-radio-small" type="radio" id="ecommerce" value="ecommerce" name="website_type"
               [checked]="websiteType === 'ecommerce'" (change)="onWebsiteTypeChange('ecommerce')">
        <label for="ecommerce">I want to create a website with<br [ngClass]="{'hidden': !isMobile}"> an online
          store</label>
      </div>
    </div>
  </div>
  <div class="db-create-ai-assistant-mobile-button first-step mt30" *ngIf="isMobile">
<!--    <div class="db-navigation-text">
      <span *ngIf="!showAsDialog && (!isFromGenerate || (!!signUpWithHubspot && !userSubscription))"
            class="back-to-previous pr8" (click)="backToPreviousStep()">Back</span>
    </div>-->

    <button class="ds-btn-black ds-btn-ls rectangle"
            [ngClass]="{'ds-btn-disabled': !websiteType || !!loading.value}"
            (click)="proceedToNextQuestion()">
      <db-loading-circular-spinner *ngIf="loading.value"></db-loading-circular-spinner>
      <span *ngIf="!loading.value">Next</span>
    </button>

  </div>
</div>

<div class="db-actions-line flex-end" *ngIf="!isMobile">
 <!-- <a class="ds-btn-m ds-btn-outline"
     (click)="backToPreviousStep()"
     *ngIf="!showAsDialog && (!isFromGenerate || (!!signUpWithHubspot && !userSubscription))">
    <span class="back-to-previous pr8">Back</span></a>-->

  <a class="ds-btn-black rectangle"
     [ngClass]="{'ds-btn-disabled': !websiteType || !!loading.value}"
     (click)="proceedToNextQuestion()">
    <db-loading-circular-spinner *ngIf="loading.value"></db-loading-circular-spinner>
    <span *ngIf="!loading.value">{{ "text_next" | dbText}}</span>
  </a>
</div>
